import React, { MutableRefObject, useRef } from "react";
import {
  Checkbox,
  Button,
  Modal,
  Spin,
  Form,
  Row,
  Col,
  Radio,
  InputNumber,
  DatePicker,
  message,
  Popconfirm,
  Input,
} from "antd";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import { DocumentCheckbox } from "../Components/DocumentCheckbox";
import moment from "moment";
import { Messages } from "../Common/ValidateMessages";
import { isNullOrSpace } from "../Common/Utils";

interface ExaminationSubjectBean {
  examinationSubjectId: string | undefined;
  subjectId: string;
  seq: string;
  scoringType: string;
  groupCreationRequiredFlag: string | undefined;
  scoringFlag: string;
  // scoringConfirmFlag: string | undefined;
  scoringAllocationFlag: string | undefined;
  scoringNumOfPeople: string | undefined;
  scoringStartDateTime: string | undefined;
  scoringEndDateTime: string | undefined;
  dispFlag_ExamNumber: string | undefined;
  dispFlag_Name: string | undefined;
  dispFlag_NameKana: string | undefined;
  dispFlag_Birthday: string | undefined;
  dispFlag_HighSchool: string | undefined;
  elapsedMinute: string | undefined;
  elapsedSecond: string | undefined;
  threshold: string | undefined;
  scoringValueType: string | undefined;
  documentIdList: string[];
  subjectName: string | undefined;
}

interface Props {
  width?: number;
  label?: string;
  fy?: string;
  maxSeq?: number;
  examinationDate?: string;
  subjectIdList?: string[];
  targetSubject?: any;
  onChange?: (targetSubjectId?: string, newData?: any) => void;
}

export const ExaminationSubjectRegisterButton = ({
  width = 100,
  label = "ボタン",
  fy,
  maxSeq,
  examinationDate,
  subjectIdList,
  targetSubject,
  onChange,
}: Props) => {
  // 入力データ整形
  const examSubject: ExaminationSubjectBean = targetSubject
    ? targetSubject
    : {
        examinationSubjectId: undefined,
        subjectId: undefined,
        seq: undefined,
        scoringType: "1",
        groupCreationRequiredFlag: undefined,
        scoringFlag: "1",
        // scoringConfirmFlag: "1",
        scoringAllocationFlag: "1",
        scoringNumOfPeople: undefined,
        scoringStartDateTime: undefined,
        scoringEndDateTime: undefined,
        dispFlag_ExamNumber: "0",
        dispFlag_Name: "0",
        dispFlag_NameKana: "0",
        dispFlag_Birthday: "0",
        dispFlag_HighSchool: "0",
        elapsedMinute: undefined,
        elapsedSecond: undefined,
        threshold: 1,
        scoringValueType: "1",
        documentIdList: [],
        subjectName: undefined,
      };
  const dispFlags: number[] = [];
  if (examSubject.dispFlag_ExamNumber === "1") {
    dispFlags.push(0);
  }
  if (examSubject.dispFlag_Name === "1") {
    dispFlags.push(1);
  }
  if (examSubject.dispFlag_NameKana === "1") {
    dispFlags.push(2);
  }
  if (examSubject.dispFlag_Birthday === "1") {
    dispFlags.push(3);
  }
  if (examSubject.dispFlag_HighSchool === "1") {
    dispFlags.push(4);
  }

  const form: MutableRefObject<any> = useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [showScoringDiv, setShowScoringDiv] = React.useState("1");
  const [showDocumentDiv, setShowDocumentDiv] = React.useState("1");
  const [showInterviewDiv, setShowInterviewDiv] = React.useState("0");
  const dateFormat = "YYYY-MM-DD HH:mm";

  const onButtonClick = () => {
    if (fy === undefined) {
      message.error("入試年度" + Messages["ERR-055"]);
      return;
    }
    if (maxSeq === undefined) {
      message.error("N次" + Messages["ERR-055"]);
      return;
    }
    if (examinationDate === undefined) {
      message.error("試験日" + Messages["ERR-055"]);
      return;
    }
    setVisible(true);

    // 初期表示
    setShowScoringDiv(
      examSubject
        ? examSubject.scoringFlag
          ? examSubject.scoringFlag
          : "1"
        : "1"
    );
    setShowDocumentDiv(
      examSubject ? (examSubject.scoringType === "2" ? "0" : "1") : "1"
    );
    setShowInterviewDiv(
      examSubject ? (examSubject.scoringType === "1" ? "0" : "1") : "0"
    );
    if (form?.current) {
      form?.current.setFieldsValue({
        seq: examSubject.seq,
        subjectId: examSubject.subjectId,
        scoringType: examSubject.scoringType,
        groupCreationRequiredFlag:
          examSubject.groupCreationRequiredFlag === "1" ? [1] : undefined,
        scoringFlag: examSubject.scoringFlag,
        // scoringConfirmFlag: examSubject.scoringConfirmFlag,
        scoringAllocationFlag: examSubject.scoringAllocationFlag,
        scoringNumOfPeople: examSubject.scoringNumOfPeople,
        scoringStartDateTime: examSubject.scoringStartDateTime
          ? moment(examSubject.scoringStartDateTime, dateFormat)
          : undefined,
        scoringEndDateTime: examSubject.scoringEndDateTime
          ? moment(examSubject.scoringEndDateTime, dateFormat)
          : undefined,
        dispFlags: dispFlags,
        elapsedMinute: examSubject.elapsedMinute,
        elapsedSecond: examSubject.elapsedSecond,
        threshold: examSubject.threshold,
        scoringValueType: examSubject.scoringValueType,
        documentIdList: examSubject.documentIdList,
      });
    }
  };

  const onChangeScoringFlag = (value: any) => {
    setShowScoringDiv(value.target.value);
  };

  const onChangeScoringType = (value: any) => {
    setShowDocumentDiv(value.target.value === "2" ? "0" : "1");
    setShowInterviewDiv(value.target.value === "1" ? "0" : "1");
  };
  const onChangeSubjectId = (value: any) => {
    if (
      examSubject.subjectId !== value.value &&
      subjectIdList !== undefined &&
      subjectIdList.find((subjectId) => subjectId === value.value) !== undefined
    ) {
      message.error("該当科目が既に登録されています。");
      form?.current.setFieldsValue({
        subjectId: "",
      });
      return;
    }
  };

  // 登録・修正ボタン押す
  const onRegister = (values: any) => {
    const dispFlags: string[] = ["0", "0", "0", "0", "0"];
    values.dispFlags.forEach((index: number) => {
      dispFlags[index] = "1";
    });
    const registerData = {
      examinationSubjectId: examSubject.examinationSubjectId,
      subjectId: values.subjectId.value
        ? values.subjectId.value
        : examSubject.subjectId,
      subjectName: values.subjectId.label
        ? values.subjectId.label
        : examSubject.subjectName,
      seq: values.seq,
      scoringType: values.scoringType,
      groupCreationRequiredFlag:
        values.groupCreationRequiredFlag !== undefined &&
        values.groupCreationRequiredFlag.length > 0
          ? "1"
          : "0",
      elapsedMinute: values.elapsedMinute,
      elapsedSecond: values.elapsedSecond,
      scoringFlag: values.scoringFlag,
      // scoringConfirmFlag: values.scoringConfirmFlag,
      scoringAllocationFlag: values.scoringAllocationFlag,
      scoringNumOfPeople: values.scoringNumOfPeople,
      scoringValueType: values.scoringValueType,
      threshold: values.threshold,
      scoringStartDateTime: values.scoringStartDateTime
        ? values.scoringStartDateTime.format(dateFormat)
        : undefined,
      scoringEndDateTime: values.scoringEndDateTime
        ? values.scoringEndDateTime.format(dateFormat)
        : undefined,
      dispFlag_ExamNumber: dispFlags[0],
      dispFlag_Name: dispFlags[1],
      dispFlag_NameKana: dispFlags[2],
      dispFlag_Birthday: dispFlags[3],
      dispFlag_HighSchool: dispFlags[4],
      documentIdList: values.scoringType === "2" ? null : values.documentIdList,
    };
    onChange?.(
      targetSubject ? targetSubject.subjectId : undefined,
      registerData
    );
    setVisible(false);
  };

  // 削除ボタン押す
  const onDelete = (values: any) => {
    onChange?.(targetSubject ? targetSubject.subjectId : undefined);
    setVisible(false);
  };

  return (
    <Spin spinning={isLoading}>
      <div>
        <Button onClick={onButtonClick} style={{ width: width }} type="primary">
          {label}
        </Button>
      </div>
      <Modal
        title={"試験科目登録/修正"}
        maskClosable={false}
        centered
        visible={visible}
        onCancel={() => setVisible(false)}
        width={900}
        footer={null}
      >
        <Form
          name="examinationSubjectRegisterForm"
          onFinish={onRegister}
          initialValues={{
            seq: examSubject.seq,
            subjectId: examSubject.subjectId,
            scoringType: examSubject.scoringType,
            groupCreationRequiredFlag:
              examSubject.groupCreationRequiredFlag === "1" ? [1] : undefined,
            scoringFlag: examSubject.scoringFlag,
            // scoringConfirmFlag: examSubject.scoringConfirmFlag,
            scoringAllocationFlag: examSubject.scoringAllocationFlag,
            scoringNumOfPeople: examSubject.scoringNumOfPeople,
            scoringStartDateTime: examSubject.scoringStartDateTime
              ? moment(examSubject.scoringStartDateTime, dateFormat)
              : undefined,
            scoringEndDateTime: examSubject.scoringEndDateTime
              ? moment(examSubject.scoringEndDateTime, dateFormat)
              : undefined,
            dispFlags: dispFlags,
            elapsedMinute: examSubject.elapsedMinute,
            elapsedSecond: examSubject.elapsedSecond,
            threshold: examSubject.threshold,
            scoringValueType: examSubject.scoringValueType,
            documentIdList: examSubject.documentIdList,
          }}
          ref={form}
        >
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={12}>
              <Form.Item label="N次" name="seq" rules={[{ required: true }]}>
                <InputNumber min={1} max={maxSeq} style={{ width: "50px" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={12}>
              <Form.Item
                label="科目"
                name="subjectId"
                rules={[{ required: true }]}
              >
                <CommonMasterSelect
                  allowClear={true}
                  masterType={20}
                  fy={fy}
                  onChange={onChangeSubjectId}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={24}>
              <Form.Item
                label="採点対象"
                name="scoringFlag"
                rules={[{ required: true }]}
              >
                <Radio.Group onChange={onChangeScoringFlag}>
                  <Radio value={"1"}>採点対象</Radio>
                  <Radio value={"0"}>対象外</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <div style={{ display: showScoringDiv === "1" ? "block" : "none" }}>
            <Row style={{ width: "100%", marginBottom: "10px" }}>
              <Col span={7}>
                <Form.Item
                  label="採点種別"
                  name="scoringType"
                  rules={[{ required: true }]}
                >
                  <Radio.Group onChange={onChangeScoringType}>
                    <Radio value={"1"}>答案</Radio>
                    <Radio value={"2"}>面接</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <div
                style={{ display: showInterviewDiv === "1" ? "block" : "none" }}
              >
                <Col span={17}>
                  <Form.Item label="面接試験経過時間アラート" required={true}>
                    <Input.Group compact>
                      <Form.Item
                        noStyle
                        name="elapsedMinute"
                        rules={[
                          {
                            validator: (
                              _: any,
                              value: string
                            ): Promise<void> => {
                              if (
                                form.current.getFieldsValue().scoringFlag ===
                                  "1" &&
                                form.current.getFieldsValue().scoringType ===
                                  "2" &&
                                !form.current.getFieldsValue().elapsedSecond &&
                                !value
                              ) {
                                return Promise.reject(
                                  new Error("必須項目です。")
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          max={99}
                          style={{ width: "50px" }}
                          precision={0}
                        />
                      </Form.Item>
                      <span style={{ marginLeft: "1px", marginRight: "1px" }}>
                        :
                      </span>
                      <Form.Item
                        noStyle
                        name="elapsedSecond"
                        rules={[
                          {
                            validator: (
                              _: any,
                              value: string
                            ): Promise<void> => {
                              if (
                                form.current.getFieldsValue().scoringFlag ===
                                  "1" &&
                                form.current.getFieldsValue().scoringType ===
                                  "2" &&
                                !form.current.getFieldsValue().elapsedMinute &&
                                !value
                              ) {
                                return Promise.reject(
                                  new Error("必須項目です。")
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <InputNumber
                          min={0}
                          max={59}
                          style={{ width: "50px" }}
                          precision={0}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name="groupCreationRequiredFlag">
                    <Checkbox.Group
                      options={[
                        {
                          label:
                            "志願者面接グループ作成必要(集団面接、グループディスカッション)",
                          value: 1,
                        },
                      ]}
                    />
                  </Form.Item>
                </Col>
              </div>
            </Row>
            <div
              style={{ display: showDocumentDiv === "1" ? "block" : "none" }}
            >
              <Row style={{ width: "100%", marginBottom: "10px" }}>
                <Col span={24}>
                  <Form.Item label="提出書類(事前課題等)" name="documentIdList">
                    <DocumentCheckbox fid={"2"} width={700} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <Row style={{ width: "100%", marginBottom: "10px" }}>
              <Col span={24}>
                <Form.Item
                  label="採点確定値種別"
                  name="scoringValueType"
                  rules={[{ required: true }]}
                >
                  <Radio.Group>
                    <Radio value={"1"}>合計点</Radio>
                    <Radio value={"2"}>平均点</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            {/* <Row style={{ width: "100%", marginBottom: "10px" }}>
              <Col span={24}>
                <Form.Item label="採点確定処理" name="scoringConfirmFlag">
                  <Radio.Group>
                    <Radio value={"1"}>行う</Radio>
                    <Radio value={"0"}>行わない</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row> */}
            <Row style={{ width: "100%", marginBottom: "10px" }}>
              <Col>
                <Form.Item
                  label="採点割り振り"
                  name="scoringAllocationFlag"
                  rules={[{ required: true }]}
                >
                  <Radio.Group>
                    <Radio value={"1"}>行う</Radio>
                    <Radio value={"0"}>行わない</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ width: "100%", marginBottom: "10px" }}>
              <Col span={24}>
                <Form.Item label="採点人数" required={true}>
                  <Form.Item
                    noStyle
                    name="scoringNumOfPeople"
                    rules={[
                      {
                        validator: (_: any, value: string): Promise<void> => {
                          if (
                            form.current.getFieldsValue().scoringFlag === "1" &&
                            !value
                          ) {
                            return Promise.reject(
                              new Error("採点人数は必須項目です。")
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <InputNumber min={1} max={5} style={{ width: "50px" }} />
                  </Form.Item>
                  &nbsp;人
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ width: "100%", marginBottom: "10px" }}>
              <Col span={24}>
                <Form.Item label="採点時アラート表示">
                  <Form.Item noStyle name="threshold">
                    <InputNumber min={0} max={99} style={{ width: "50px" }} />
                  </Form.Item>
                  &nbsp;点
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ width: "100%" }}>
              <Col span={24}>
                <Form.Item
                  required={true}
                  label="採点開始日時"
                  name="scoringStartDateTime"
                  rules={[
                    {
                      validator: (_: any, value: string): Promise<void> => {
                        if (
                          form.current.getFieldsValue().scoringFlag === "1" &&
                          isNullOrSpace(value)
                        ) {
                          return Promise.reject(
                            new Error("採点開始日時は必須項目です。")
                          );
                        } else if (
                          form.current.getFieldsValue().scoringFlag === "1" &&
                          !isNullOrSpace(value)
                        ) {
                          let date1 = moment(`${examinationDate} 00:00:00`);
                          let date2 = moment(value);
                          if (date1.isAfter(date2)) {
                            return Promise.reject(
                              new Error(
                                "採点開始日時は、試験日以降の日付を入力してください。"
                              )
                            );
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ width: "100%", marginBottom: "10px" }}>
              <Col span={24}>
                <Form.Item
                  required={true}
                  label="採点終了日時"
                  name="scoringEndDateTime"
                  rules={[
                    {
                      validator: (_: any, value: string): Promise<void> => {
                        if (
                          form.current.getFieldsValue().scoringFlag === "1" &&
                          isNullOrSpace(value)
                        ) {
                          return Promise.reject(
                            new Error("採点終了日時は必須項目です。")
                          );
                        } else if (
                          form.current.getFieldsValue().scoringFlag === "1" &&
                          !isNullOrSpace(
                            form.current.getFieldsValue().scoringStartDateTime
                          ) &&
                          !isNullOrSpace(value)
                        ) {
                          let date2 = moment(value);
                          let date1 = moment(
                            form.current.getFieldsValue().scoringStartDateTime
                          );
                          if (date1.isAfter(date2)) {
                            return Promise.reject(
                              new Error(
                                "採点終了日時は、採点開始日時より大きい日時を入力してしてください。"
                              )
                            );
                          }
                          date1 = moment(`${examinationDate} 00:00:00`);
                          if (date1.isAfter(date2)) {
                            return Promise.reject(
                              new Error(
                                "採点終了日時は、試験日以降の日付を入力してください。"
                              )
                            );
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <DatePicker
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ width: "100%", marginBottom: "20px" }}>
              <Col>
                <Form.Item label="採点画面への表示" name="dispFlags">
                  <Checkbox.Group
                    options={[
                      { label: "受験番号", value: 0 },
                      { label: "氏名", value: 1 },
                      { label: "氏名カナ", value: 2 },
                      { label: "生年月日", value: 3 },
                      { label: "高校", value: 4 },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          <Row style={{ width: "100%", marginBottom: "10px" }}>
            <Col span={4} offset={10}>
              {targetSubject !== undefined && (
                <Popconfirm
                  title={Messages["CON-001"]}
                  okText="はい"
                  cancelText="いいえ"
                  onConfirm={onDelete}
                >
                  <Button type="primary" htmlType="button">
                    削除
                  </Button>
                </Popconfirm>
              )}
            </Col>
            <Col span={4}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  登録/修正
                </Button>
              </Form.Item>
            </Col>
          </Row>
          <Row style={{ width: "100%" }}>
            <Col span={22} offset={2}>
              ※試験登録/修正画面で[登録]ボタンが押されるまでは、ここで登録した内容は反映されません
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};
